import { post } from '../../../utils/services/Request'

/**
 * Récupère la liste des fittings en fonction des filtres
 * @param filters
 */
export const getFittingsWithFilters = (filters: string) => post('/fittings', filters)